import { facadeApi } from 'api'
import { AzGroup, GroupFormEditDTO } from 'types/groups/groups'

interface Params {
  id: string
  group: GroupFormEditDTO
}

export const editGroupApi = ({ id, group }: Params) => facadeApi.put<AzGroup>(`/az/groups/${id}`, group)
